<rs-top-bar-menu
  (onLogout)="onLogout()"
  (onRouteChange)="onRouteChange($event)"
  [application]="'ORD'"
  [menuItems]="menuItems()"
/>

<rs-loader />

<router-outlet />

<rs-footer />